import { gql } from "@apollo/client";

// A presigned PUT for one artist portrait, straight from the browser to S3.
// The server signs the file's exact size into the URL, so S3 refuses anything
// over 1MB whatever the browser claims.
const GET_BROCHURE_PORTRAIT_UPLOAD_URL = gql`
  query GetBrochurePortraitUploadUrl($input: BrochurePortraitUploadInput!) {
    getBrochurePortraitUploadUrl(input: $input) {
      success
      error
      uploadUrl
      handle
      viewUrl
    }
  }
`;

// Somewhere to show a portrait uploaded in an earlier session from.
const FETCH_BROCHURE_PORTRAIT_VIEW_URL = gql`
  query FetchBrochurePortraitViewUrl($handle: String!) {
    brochurePortraitViewUrl(handle: $handle) {
      success
      error
      viewUrl
    }
  }
`;

export { GET_BROCHURE_PORTRAIT_UPLOAD_URL, FETCH_BROCHURE_PORTRAIT_VIEW_URL };
